import { z } from '../utils/zod-extend'

export const pageMetaSchema = z.object({
  title: z.string(),
  url: z.string(),
  referrer: z.string(),
  insertId: z.string(),
  localDate: z.number(),
  screenWidth: z.number().optional(),
  screenHeight: z.number().optional(),
  innerWidth: z.number().optional(),
  innerHeight: z.number().optional(),
  outerWidth: z.number().optional(),
  outerHeight: z.number().optional(),
})
export type PageMeta = z.infer<typeof pageMetaSchema>
